import moment from "moment";
import {v4 as uuid} from "uuid";
import oggettiUtili from "./OggettiUtili.json"
import AnagraficaService from "../services/AnagraficaService";
import AssistentiService from "../services/AssistentiService";
import {setAssistente, setStateAssistente, setUpload} from "../actions/IndexActions";
import atob from "atob"
import sessionStorage from "redux-persist/es/storage/session";
import SportelliService from "../services/SportelliService";
import ReportService from "../services/ReportService";
import Enums from "./Enums.json"
import ApmsService from "../services/ApmsService";

export default class Utils {

    static AreObjectsEquals(object1, object2) {
        if (object1 && object2) {
            for (let key in object1) {
                if (object1.hasOwnProperty(key) && !object2.hasOwnProperty(key)) {
                    return false
                } else if (object1[key] !== object2[key]) {
                    return false
                }
            }
            return true
        }
        return true
    }

    static IconAnnullaElenchi() {
        return (
            <div style={{marginRight: "10px"}}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                     className="bi bi-arrow-up" viewBox="0 0 16 16">
                    <path fillRule="evenodd"
                          d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"/>
                </svg>
            </div>
        )
    }

    static addQueryParamsToRequestUrl(params) {
        let querystring = "?";

        Object.keys(params).forEach(function (key) {
            if (Array.isArray(params[key])) {
                params[key].forEach(p => {
                    querystring += key + "=" + p + "&";
                })
            } else {
                querystring += key + "=" + params[key] + "&";
            }

        });
        querystring = querystring.substring(0, querystring.length - 1);
        return querystring
    }


    static distinctComuni(comuni, dataOdierna) {
        let distinctComuni = [];
        if (dataOdierna) {
            for (let i = 0; i < comuni.length; i++) {
                if (comuni[i].codice !== (comuni[i + 1] && comuni[i + 1].codice) && (!comuni[i].dataFineValidita || comuni[i].dataFineValidita > dataOdierna)) {
                    distinctComuni.push(comuni[i]);
                } else if ((comuni[i + 1] && comuni[i].codice === comuni[i + 1].codice) && (comuni[i + 1] && comuni[i].codiceProvincia === comuni[i + 1].codiceProvincia) && (!comuni[i].dataFineValidita || comuni[i].dataFineValidita && comuni[i].dataFineValidita > dataOdierna)) {
                    distinctComuni.splice(i, 1, comuni[i]);
                }
            }
        } else {
            for (let i in comuni) {
                if (i == 0) {
                    distinctComuni.push(comuni[i]);
                } else {
                    if (comuni[i].descrizione !== comuni[i - 1].descrizione) {
                        distinctComuni.push(comuni[i]);
                    } else if (distinctComuni[distinctComuni.length - 1].dataFineValidita < comuni[i].dataFineValidita || !comuni[i].dataFineValidita) {
                        distinctComuni.splice(distinctComuni.length - 1, 1, comuni[i]);
                    }
                }
            }
        }
        return distinctComuni
    }

    //Converte un array in una mappa ponendo come chiave il key se passato
    static arrayToMap(array, key) {
        if (array) {
            let map = {};

            for (let i = 0; i < array.length; i++) {
                if (key)
                    map[array[i][key]] = array[i];
                else
                    map[i] = array[i];
            }
            return map;
        } else {
            return null;
        }
    }

    static addFieldToArrayObjects(array, field1, field2, newField) {
        array.forEach(element => {
            element[newField] = element[field1] + " - " + element[field2];
        });

        return array;
    }

    static transformDateForFrontend(date) {
        if (moment(date, "YYYY-MM-DD", true).isValid() && date.replace)
            return date.replace(/(\d{4})-(\d{2})-(\d{2})/, "$3/$2/$1");
        else if (moment(date, "MM-DD-YYYY", true).isValid() && date.replace) {
            return date.replace(/(\d{2})-(\d{2})-(\d{4})/, "$1/$2/$3");
        } else return date;
    }

    static transformDateForBackend(date) {
        if (moment(date, "DD/MM/YYYY", true).isValid() && date.replace)
            return date.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3-$2-$1");
        else return date;
    }

    static riceviValore(state, id, value) {
        let newState = {...state}
        newState[id] = value
        return newState
    }

    static riceviValoreMultiValue(state, id, value, index) {

        let newState = {...state}
        let newId = id.replace(index, '');

        if (!(newState && newState[newId])) newState[newId] = []

        let newValue = []
        newValue[index] = value
        Object.assign(newState[newId], newValue);

        return newState

    }

    static riceviValorePadre(state, id, value, padre) {

        let newState = {...state}
        let newValue = {};
        newValue[id] = value

        if (!(newState && newState[padre])) newState[padre] = {}
        Object.assign(newState[padre], newValue);

        return newState
    }

    static createJsonUtente(utente, suggestionsSportelli, comuniPerCodice) {
        let jsonUtete = {}
        let nomeSportello = ""
        let codiceComune = ""
        let codiceSportello = ""
        let valoreEnte = ""
        let valoreUltimoLogin = ""
        let valoreTelefono = ""
        let codiceGruppo = ""
        if (utente.ente && utente.telefono) {
            if (Array.isArray(utente.ente)) {
                utente.ente.forEach(ente => {
                    suggestionsSportelli.forEach((sportello, index) => {
                        if (sportello.codice.toString() === ente.toString()) {
                            nomeSportello = sportello.descrizione.toUpperCase()
                            codiceComune = sportello.codiceComune
                            codiceSportello = sportello.codice
                            valoreEnte = valoreEnte.concat(nomeSportello + ";" + comuniPerCodice[codiceComune].codice + ";" + comuniPerCodice[codiceComune].descrizione + ";" + codiceSportello + "|")
                        }
                    })
                })
            } else {
                valoreEnte = utente.ente
            }

            valoreUltimoLogin = utente.ultimoLogin
            valoreTelefono = utente.telefono
            codiceGruppo = utente.ruolo
        } else if (utente.gruppi) {
            utente.gruppi.forEach(gruppo => {
                if (gruppo.attributi) {
                    gruppo.attributi.forEach(attributo => {
                        if (attributo.codiceAttributo.toUpperCase() === "RAF-ente".toUpperCase()) {
                            valoreEnte = attributo.valore
                        } else if (attributo.codiceAttributo.toUpperCase() === "RAF-ultimoLogin".toUpperCase()) {
                            valoreUltimoLogin = attributo.valore
                        } else if (attributo.codiceAttributo.toUpperCase() === "RAF-telefono".toUpperCase()) {
                            valoreTelefono = attributo.valore
                        }
                    })
                }
                codiceGruppo = gruppo.codice_gruppo
            })
        }
        jsonUtete.applicazione = "RAF"
        jsonUtete.struttura = "spid"
        jsonUtete.codiceFiscale = utente.codiceFiscale.toUpperCase()
        jsonUtete.nome = utente.nome.toUpperCase()
        jsonUtete.cognome = utente.cognome.toUpperCase()
        jsonUtete.mail = utente.mail
        jsonUtete.utentelocale = false
        let enteSenzaPipe = valoreEnte ? valoreEnte.slice(0, valoreEnte.length - 1) : ""
        jsonUtete.listaGruppi = [
            {
                codicegruppo: codiceGruppo,
                listaAttributi: [
                    {
                        codiceAttributo: "RAF-ente",
                        valore: enteSenzaPipe
                    },
                    {
                        codiceAttributo: "RAF-ultimoLogin",
                        valore: valoreUltimoLogin
                    },
                    {
                        codiceAttributo: "RAF-telefono",
                        valore: valoreTelefono
                    },
                    {
                        codiceAttributo: "RAF-nome",
                        valore: utente.nome.toUpperCase()
                    },
                    {
                        codiceAttributo: "RAF-cognome",
                        valore: utente.cognome.toUpperCase()
                    }
                ]
            }
        ]
        return jsonUtete
    }

    static createListaUtentiFromApms(listaUtentiApms) {
        let listaUtenti = []
        listaUtentiApms.forEach(utenteApms => {
            if (utenteApms.gruppi && utenteApms.gruppi.length > 0) {
                utenteApms.gruppi.forEach(gruppo => {
                    let utente = {
                        id: uuid(),
                        cognome: utenteApms.cognome,
                        nome: utenteApms.nome,
                        codiceFiscale: utenteApms.codiceFiscale,
                        mail: utenteApms.mail,
                        ruolo: gruppo.codice_gruppo
                    }
                    gruppo.attributi.forEach(attributo => {
                        if (attributo.codiceAttributo.toUpperCase() === "RAF-telefono".toUpperCase()) {
                            utente.telefono = attributo.valore
                        } else if (attributo.codiceAttributo.toUpperCase() === "RAF-ente".toUpperCase()) {
                            utente.ente = attributo.valore
                            let valoreEnte = attributo.valore.split("|")
                            let descrizioniEnti = ""
                            valoreEnte.forEach((ente, index) => {
                                if (ente) {
                                    let enteDescrizione = ente.split(";")[0]
                                    descrizioniEnti = index === (valoreEnte.length - 1) ? descrizioniEnti.concat(enteDescrizione) : descrizioniEnti.concat(enteDescrizione).concat("|")
                                }
                            })
                            utente.enteDescrizione = descrizioniEnti
                        } else if (attributo.codiceAttributo.toUpperCase() === "RAF-ultimoLogin".toUpperCase()) {
                            let ultimoLogin = attributo.valore ? attributo.valore.substring(0, attributo.valore.indexOf("T")) : ""
                            utente.ultimoLogin = ultimoLogin
                        }
                    })
                    listaUtenti.push(utente)
                })
            }
        })
        return listaUtenti
    }

    static removeEmptyObject(object) {
        let newObject = {...object}

        for (let key in object) {
            if (typeof object[key] === 'object') {
                for (let keyInterna in object[key]) {
                    if (Object.keys(object[key][keyInterna]).length === 0) {
                        delete newObject[key][keyInterna]
                    }
                }
                if (Object.keys(object[key]).length === 0) {
                    delete newObject[key]
                }
            }
        }

        return newObject
    }

    static validateCheckbox(object) {
        for (let key in object) {
            if (object[key]) return false
        }

        return true
    }

    static isEmpty(obj) {
        for (let key in obj) {
            if (obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }

    static removeEmptyValueFromObject(obj) {

        Object.keys(obj).forEach(function (key) {


            if (Array.isArray(obj[key])) {
                if (Object.values(obj[key]).length === 0) {
                    delete (obj[key])
                }
            }
            if (obj[key] === '' || obj[key] === null ||
                obj[key] === undefined) {
                delete obj[key]
            } else if (Array.isArray(obj[key])) {
                if (Object.values(obj[key]).length !== 0) {
                    let array = Object.values(obj[key])
                    for (let i = 0; i < array.length; i++) {
                        if (array[i] && typeof array[i] === 'object') {
                            if (Utils.isEmpty(array[i])) {
                                array.splice(i, 1)
                                obj[key] = array
                                Utils.removeEmptyValueFromObject(obj)
                            }
                        } else if (array[i] === '' || array[i] === null ||
                            array[i] === undefined) {
                            array.splice(i, 1)
                            obj[key] = array
                            Utils.removeEmptyValueFromObject(obj)
                        }
                    }
                } else if (Object.values(obj[key]).length === 0) {
                    delete (obj[key])
                    Utils.removeEmptyValueFromObject(obj)
                }
            } else if (obj[key] && typeof obj[key] === 'object') {
                if (Utils.isEmpty(obj[key])) {
                    delete (obj[key])
                    Utils.removeEmptyValueFromObject(obj)
                } else {
                    Utils.removeEmptyValueFromObject(obj[key])
                }
            }

        })
        console.log(obj)
        return obj;
    }

    static createObjectDatiAnagraficiAssistente(datiAnagrafici, comuniPerCodice, siglaProvincePerCodice, nazioniPerCodice, flagProvinciaNascita) {
        let comuni = comuniPerCodice ? comuniPerCodice : JSON.parse(sessionStorage.getItem("comuniPerCodice"))
        let province = siglaProvincePerCodice ? siglaProvincePerCodice : JSON.parse(sessionStorage.getItem("siglaProvincePerCodice"))
        let nazioni = nazioniPerCodice ? nazioniPerCodice : JSON.parse(sessionStorage.getItem("nazioniPerCodice"))
        datiAnagrafici.comuneNascita = comuni[datiAnagrafici.comuneNascita] ? comuni[datiAnagrafici.comuneNascita] : nazioni[datiAnagrafici.comuneNascita] ? nazioni[datiAnagrafici.comuneNascita] : ""
        if (!flagProvinciaNascita) {
            datiAnagrafici.provinciaNascita = province[datiAnagrafici.provinciaNascita] ? province[datiAnagrafici.provinciaNascita] : ""
        }
        datiAnagrafici.dataNascita = Utils.transformDateForFrontend(datiAnagrafici.dataNascita)
        datiAnagrafici.cittadinanza = nazioniPerCodice[datiAnagrafici.cittadinanza] ? nazioniPerCodice[datiAnagrafici.cittadinanza] : ""
        datiAnagrafici.residenzaDiversaDomicilio = datiAnagrafici.residenzaDiversaDomicilio ? "true" : "false"
        if (datiAnagrafici.indirizzi) {
            datiAnagrafici.indirizzi.forEach(indirizzo => {
                indirizzo.comune = comuni[indirizzo.comune] ? comuni[indirizzo.comune] : nazioni[indirizzo.comune]?nazioni[indirizzo.comune]:""
                indirizzo.provincia = province[indirizzo.provincia] ? province[indirizzo.provincia] : ""
                indirizzo.nazione = nazioni[indirizzo.nazione] ? nazioni[indirizzo.nazione] : ""
                indirizzo.regione = oggettiUtili.regioni[indirizzo.regione] ? oggettiUtili.regioni[indirizzo.regione] : ""
            })

            datiAnagrafici.indirizzi.sort((a, b) => (a.tipoIndirizzo > b.tipoIndirizzo) ? 1 : -1)
        }
        if (datiAnagrafici.documenti) {
            datiAnagrafici.documenti.forEach(documento => {
                documento.dataRilascio = Utils.transformDateForFrontend(documento.dataRilascio)
                documento.dataScadenza = Utils.transformDateForFrontend(documento.dataScadenza)
            })
            datiAnagrafici.documenti.sort((a, b) => (a.tipo > b.tipo) ? 1 : -1)

            if (datiAnagrafici.documenti.length === 1 && datiAnagrafici.documenti[0].tipo === 2) {
                datiAnagrafici.documenti.splice(0, 0, {})
            }

        }

        return datiAnagrafici
    }

    static recuperaDatiAssistente(id, dispatch, history, path, comuniPerCodice, siglaProvincePerCodice, nazioniPerCodice, provincePerCodice) {

        let params = {idCandidato: id}
        AnagraficaService.getCandidato(id).then(resCandidato => {
            let datiAnagraficiAssistente = Utils.createObjectDatiAnagraficiAssistente(resCandidato.data, comuniPerCodice, siglaProvincePerCodice, nazioniPerCodice)
            datiAnagraficiAssistente.provinciaNascita = provincePerCodice[datiAnagraficiAssistente.provinciaNascita.codice]
            dispatch(setStateAssistente("datiAnagrafici", datiAnagraficiAssistente ? datiAnagraficiAssistente : {}))
            AssistentiService.getAssistente(params).then(res => {
                if (res.data) {
                    dispatch(setAssistente(res.data))
                    dispatch(setStateAssistente("infoGenerali", res.data && res.data.datiPersonali && res.data.datiPersonali.infoGenerali ? res.data.datiPersonali.infoGenerali : {}))
                    dispatch(setStateAssistente("esperienzeLavorative", res.data && res.data.lavoroDisponibilita && res.data.lavoroDisponibilita.esperienzeLavorative ? res.data.lavoroDisponibilita.esperienzeLavorative : {}))
                    dispatch(setStateAssistente("disponibilitaOfferta", res.data && res.data.lavoroDisponibilita && res.data.lavoroDisponibilita.disponibilitaOfferta ? res.data.lavoroDisponibilita.disponibilitaOfferta : {}))
                    dispatch(setStateAssistente("requisitiIscrizione", res.data && res.data.requisitiCondizioni && res.data.requisitiCondizioni.requisitiIscrizione ? res.data.requisitiCondizioni.requisitiIscrizione : {}))
                    dispatch(setStateAssistente("datiPersonali", res.data && res.data.requisitiCondizioni && res.data.requisitiCondizioni.datiPersonali ? res.data.requisitiCondizioni.datiPersonali : {}))
                    dispatch(setStateAssistente("valutazione", res.data && res.data.requisitiCondizioni && res.data.requisitiCondizioni.valutazione ? res.data.requisitiCondizioni.valutazione : {}))
                }

                AssistentiService.getFile(params).then(resFiles => {
                    if (resFiles && resFiles.data && resFiles.data.documentoIdentita) {
                        dispatch(setUpload("documentoIdentita", resFiles.data.documentoIdentita))
                    }
                    if (resFiles && resFiles.data && resFiles.data.permessoSoggiorno) {
                        dispatch(setUpload("permessoSoggiorno", resFiles.data.permessoSoggiorno))
                    }
                    if (resFiles && resFiles.data && resFiles.data.attestati) {
                        dispatch(setUpload("attestati", resFiles.data.attestati))
                    }
                    history.push({
                        pathname: path
                    })
                }).catch(reason => {
                    history.push({
                        pathname: path
                    })
                    console.log("Errore Operation GET files: " + reason)
                })
            }).catch(reason => {
                history.push({
                    pathname: path
                })
                console.log("Errore Operation GET Assisetente: " + reason)
            })
        }).catch(reason => {
            history.push({
                pathname: path
            })
            console.log("Errore Operation GET Candidato: " + reason)
        })
    }

    static createJsonInsertCandidato(candidato) {
        let newCandidato = {...candidato}
        newCandidato.comuneNascita = newCandidato.comuneNascita && newCandidato.comuneNascita.codice ? newCandidato.comuneNascita.codice : newCandidato.comuneNascita
        newCandidato.provinciaNascita = newCandidato.provinciaNascita && newCandidato.provinciaNascita.codice ? newCandidato.provinciaNascita.codice : newCandidato.provinciaNascita
        newCandidato.cittadinanza = newCandidato.cittadinanza && newCandidato.cittadinanza.codice ? newCandidato.cittadinanza.codice : newCandidato.cittadinanza
        newCandidato.dataNascita = Utils.transformDateForBackend(newCandidato.dataNascita)
        newCandidato.residenzaDiversaDomicilio = newCandidato.residenzaDiversaDomicilio === "true"
        newCandidato.indirizzi.forEach((indirizzo, index) => {
            indirizzo.comune = indirizzo.comune && indirizzo.comune.codice ? indirizzo.comune.codice : indirizzo.comune
            indirizzo.provincia = indirizzo.provincia && indirizzo.provincia.codice ? indirizzo.provincia.codice : indirizzo.provincia
            indirizzo.regione = indirizzo.regione && indirizzo.regione.codice ? indirizzo.regione.codice : indirizzo.regione
            indirizzo.nazione = indirizzo.nazione && indirizzo.nazione.codice ? indirizzo.nazione.codice : "100"
            indirizzo.tipoIndirizzo = index > 0 ? 2 : 1
        })
        newCandidato.documenti.forEach(documento => {
            documento.dataRilascio = Utils.transformDateForBackend(documento.dataRilascio)
            documento.dataScadenza = Utils.transformDateForBackend(documento.dataScadenza)
        })

        newCandidato.documenti = Utils.removeEmptyValueFromObject(newCandidato.documenti)
        newCandidato.indirizzi = Utils.removeEmptyValueFromObject(candidato.indirizzi)

        return newCandidato
    }

    static downloadReport = (byte, fileName, extension, fileFirmato = false) => {
        let mimeType = {
            pdf: 'application\/pdf',
            xml: 'application/xml',
            xls: 'application\/vnd.ms-excel',
            xlsx: 'application\/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            doc: 'application\/msword',
            docx: 'application\/vnd.openxmlformats-officedocument.wordprocessingml.document',
            zip: 'application/octet-stream',
            p7m: 'application/pkcs7-mime'
        }
        let byteCharacters
        if (fileFirmato)
            byteCharacters = byte;
        else
            byteCharacters = atob(byte);

        let byteArrays = [];
        let sliceSize = 512;
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            let slice = byteCharacters.slice(offset, offset + sliceSize);
            let byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            let byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        let blob = new Blob(byteArrays, {type: mimeType[extension]});
        if (window.navigator.msSaveBlob) {
            navigator.msSaveBlob(blob, fileName + '.' + extension)
            return;
        }
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = fileName + '.' + extension;
        document.body.appendChild(a);
        a.click();
    }

    static visualizzaPdf(byte) {
        let arrayBuffer = Uint8Array.from(atob(byte), c => c.charCodeAt(0))
        let blob = new Blob([arrayBuffer], {type: 'application/pdf;base64'});
        let fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
    }

    static recuperoDatiSintesiCandidato(cf, dispatch, history, setShowSpinner, path, comuniPerCodice, siglaProvincePerCodice, nazioniPerCodice, provincePerCodice) {
        let params = {
            codiceFiscale: cf
        }
        AnagraficaService.getCandidatoByCodiceFiscale(params).then(res => {
            Utils.recuperaDatiAssistente(res.data[0].id, dispatch, history, path, comuniPerCodice, siglaProvincePerCodice, nazioniPerCodice, provincePerCodice)
            if (setShowSpinner) setShowSpinner(false)
        }).catch(reason => {
            console.log("Errore operation GET DatiSinetesiCandidato: " + reason)
            sessionStorage.setItem("sessioneUtente", JSON.stringify({tipoUtente: "03", loggedIn: false}))
            history.push({
                pathname: '/unauthorized',
                state: {flagDatiMancanti: true}
            })
            if (setShowSpinner) setShowSpinner(false)
        })
    }

    static isDateInValid(string, delimiter) {
        return !(moment(string, `YYYY${delimiter}MM${delimiter}DD`, true).isValid())
    }

    static isDateValid(string, delimiter) {
        return (moment(string, `YYYY${delimiter}MM${delimiter}DD`, true).isValid())
    }

    static saveSuggestionsSportelli(setShowSpinner, setSuggestionsSportelli) {

        setShowSpinner(true)
        SportelliService.getSportelli({paginazione: false}).then(res => {
            let sportelli = res.data
            let newSuggestionsSportelli = []
            sportelli.forEach((sportello) => {
                let s = {
                    codice: sportello.id,
                    codiceComune: sportello.comune.codice,
                    descrizione: "Sportello " + sportello.comune.descrizione + " - " + sportello.indirizzo
                }
                newSuggestionsSportelli.push(s)
            })
            setSuggestionsSportelli(newSuggestionsSportelli)
            setShowSpinner(false)
        }).catch(reason => {
            console.log("Errore GET sportelli: " + reason)
            setShowSpinner(false)
        })
    }

    static putReport(json) {
        ReportService.putReport(json).then(res => {
        }).catch(reason => {
            console.log("Errore Operation POST Report: " + reason)
        })
    }

    static createColsElencoUtenti(setShowSpinner, setCols, onClickButtonModifica, styleButtonTable) {

        setShowSpinner(true)
        SportelliService.getSportelli({paginazione: false}).then(res => {
            let sportelli = []
            res.data.forEach(sportello => {
                let s = {
                    codice: sportello.id,
                    codiceComune: sportello.comune.codice,
                    descrizione: "Sportello " + sportello.comune.descrizione + " - " + sportello.indirizzo
                }
                sportelli.push(s)
            })
            let newSportelliPerCodice = Utils.arrayToMap(sportelli, "codice")
            setCols([
                {name: "Cognome", key: "cognome", typeSort: "ASC"},
                {name: "Nome", key: "nome", typeSort: "ASC"},
                {name: "Ente", key: "enteDescrizione", typeSort: "ASC"},
                {name: "Codice fiscale", key: "codiceFiscale", typeSort: "ASC", type: "cf"},
                {name: "Telefono", key: "telefono", typeSort: "ASC"},
                {name: "Email", key: "mail", typeSort: "ASC"},
                {name: "Ruolo", key: "ruolo", typeSort: "ASC"},
                {name: "Ultimo login", key: "ultimoLogin", typeSort: "ASC"},
                {
                    type: "button",
                    key: "id",
                    onClick: onClickButtonModifica,
                    typeButton: "White",
                    text: "Modifica profilo",
                    className: styleButtonTable,
                    check: "checkUtente"
                }
            ])
        }).catch(reason => {
            console.log("Errore GET sportelli: " + reason)
            setShowSpinner(false)
        })
    }

    static toBase64(file) {
        return new Promise(function (resolve, reject) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result.split(',')[1]);
            reader.onerror = error => reject(error);
        });
    }

    static saveAs(blob, fileName) {
        var url = window.URL.createObjectURL(blob);

        var anchorElem = document.createElement("a");
        anchorElem.style = "display: none";
        anchorElem.href = url;
        anchorElem.download = fileName;

        document.body.appendChild(anchorElem);
        anchorElem.click();

        document.body.removeChild(anchorElem);

        // On Edge, revokeObjectURL should be called only after
        // a.click() has completed, atleast on EdgeHTML 15.15048
        setTimeout(function () {
            window.URL.revokeObjectURL(url);
        }, 1000);
    }

    static checkStringInArray(array) {
        let ok = false
        let newArray = array.split(",")
        for (let key in newArray) {
            if (oggettiUtili.gruppiRAF.includes(newArray[key].toUpperCase())) {
                ok = true
            } else {
                ok = false
                return ok;
            }
        }
        return ok
    }

    static alert() {
        // Priorità di visualizzazione
        let vis = 1000;


        //CONFIRM
        window.alert = function (type, message, identificativo) {
            let a = document.createElement('div');
            let y = document.createElement('button');
            //regole di stile CSS
            a.style.cssText = type === Enums.TOASTERTYPE.SUCCESS.descrizione ?
                "width:50%; border:none; border-radius:0; padding:10px; background:#1B7EA9; display:flex; align-items:center; " +
                "box-shadow:0px 0px 8px #0006; position:fixed; top:20px; right:0; left:0; margin:auto; font-family: \"Arial\", sans-serif; color:white;z-index:" + vis + ";" :
                type === Enums.TOASTERTYPE.ERROR.descrizione ?
                    "width:50%; border:none; border-radius:0; padding:10px; background:#bf023d; display:flex; align-items:center; " +
                    "box-shadow:0px 0px 8px #0006; position:fixed; top:20px; right:0; left:0; margin:auto; font-family: \"Arial\", sans-serif; color:white;z-index:" + vis + ";" :
                    "width:50%; border:none; border-radius:0; padding:10px; background:#986f01; display:flex; align-items:center; " +
                    "box-shadow:0px 0px 8px #0006; position:fixed; top:20px; right:0; left:0; margin:auto; font-family: \"Arial\", sans-serif; color:white;z-index:" + vis + ";"

            //stile dei buttons
            y.style.cssText = type === Enums.TOASTERTYPE.SUCCESS.descrizione ? "position:absolute;top:0; right:0;margin:2px;clear:both;background:#1B7EA9;border:none;color:white;outline:none;" :
                type === Enums.TOASTERTYPE.ERROR.descrizione ?
                    "position:absolute;top:0; right:0;margin:2px;clear:both;background:#bf023d;border:none;color:white;outline:none;" :
                    "position:absolute;top:0; right:0;margin:2px;clear:both;background:#986f01;border:none;color:white;outline:none;"


            y.className = type === Enums.TOASTERTYPE.SUCCESS.descrizione ? "btn btn-outline-secondary btn-sm shadow-none" :
                type === Enums.TOASTERTYPE.ERROR.descrizione ?
                    "btn btn-danger btn-sm shadow-none" :
                    "btn btn-outline-secondary btn-sm shadow-none"
            a.innerHTML = type === Enums.TOASTERTYPE.SUCCESS.descrizione ? "<div class='row' style='align-items: center;width: 100%' ><div class='col-2' style='align-items: center;justify-content: center;display: flex; height: 100px;border-right: 2px solid;margin-right: 1rem;'><svg viewBox='0 0 24 24' fill='white' id='it-check-circle' width='50' height='50' xmlns='http://www.w3.org/2000/svg'> " +
                " <path d='M17.1 7.9l.7.7-7.8 7.6-4.7-4.6.7-.7 4 3.9zM22 12A10 10 0 1112 2a10 10 0 0110 10zm-1 0a9 9 0 10-9 9 9 9 0 009-9z'/> " +
                " <path fill='none' d='M0 0h24v24H0z' /></svg></div><div class='col-9'><span><b>SUCCESSO</b></span><br/>" + message + "</div></div>" :
                type === Enums.TOASTERTYPE.ERROR.descrizione && identificativo ?
                    "<div class='row' style='align-items: center;width: 100%'><div class='col-2' style='align-items: center;justify-content: center;display: flex; height: 100px;border-right: 2px solid;margin-right: 1rem;'>" +
                    "<svg viewBox='0 0 24 24' id='it-error' fill='white' width='50' height='50' xmlns='http://www.w3.org/2000/svg'> " +
                    " <path d='M11.5 14.2V5.7h1.2v8.5zm-.1 4.1h1.2v-1.8h-1.2zM22 7.9v8.3L16.1 22H7.9L2 16.2V7.9L7.9 2h8.2zm-1 .4L15.7 3H8.3L3 8.3v7.5L8.3 21h7.4l5.3-5.2z'/> " +
                    " <path fill='none' d='M0 0h24v24H0z' /></svg></div><div class='col-9' style='height: 100px'><span><b>ERRORE</b></span><br/><span>" + message + "</span><p style='font-size: 14px; text-align: right;'>" + identificativo + "</div></p></div>" :
                    type === Enums.TOASTERTYPE.ERROR.descrizione && !identificativo ?
                        "<div class='row' style='align-items: center;width: 100%'><div class='col-2' style='align-items: center;justify-content: center;display: flex; height: 100px;border-right: 2px solid;margin-right: 1rem;'>" +
                        "<svg viewBox='0 0 24 24' id='it-error' fill='white' width='50' height='50' xmlns='http://www.w3.org/2000/svg'> " +
                        " <path d='M11.5 14.2V5.7h1.2v8.5zm-.1 4.1h1.2v-1.8h-1.2zM22 7.9v8.3L16.1 22H7.9L2 16.2V7.9L7.9 2h8.2zm-1 .4L15.7 3H8.3L3 8.3v7.5L8.3 21h7.4l5.3-5.2z'/> " +
                        " <path fill='none' d='M0 0h24v24H0z' /></svg></div><div class='col-9' style='height: 100px'><span><b>ERRORE</b></span><br/><span>" + message + "</span></div></div>" :
                        "<div class='row' style='align-items: center;width: 100%'><div class='col-2' style='align-items: center;justify-content: center;display: flex;margin-right: 1rem;'>" +
                        "<svg viewBox='0 0 24 24' id='it-info-circle' fill='white' width='50' height='50' xmlns='http://www.w3.org/2000/svg'> " +
                        "<path d='M12 2a10 10 0 1010 10A10 10 0 0012 2zm0 19a9 9 0 119-9 9 9 0 01-9 9zm-.7-15h1.5v2h-1.5zm0 3h1.5v9h-1.5z'/>" +
                        "<path fill='none' d='M0 0h24v24H0z'/></svg></div><div class='col-9' style='border-left: 2px solid'><span><b>Attenzione</b></span><br/>" + message + "</div></div>"
            y.innerHTML = "X";

            document.body.appendChild(a);
            a.appendChild(y);
            vis--;

            setTimeout(function () {
                a.remove();
            }, 15000);

            // caso YES
            y.addEventListener("click", function (e) {
                    a.remove();
                }
            )
        };
    }

    static parseJwt(token) {
        let base64Url = token.split('.')[1];
        let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        let jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    }

    static recuperoGruppiPerApplicazione(setShowSpinner, setSuggestionsSportelli, setGruppiPerApplicazione, sessioneUtente) {
        ApmsService.getGruppiPerApplicazione().then(res => {
            let gruppiApplicazione = []
            res.data.forEach((gruppo) => {
                let gruppoApplicazione = {
                    codice: gruppo.codiceGruppo,
                    descrizione: gruppo.codiceGruppo
                }
                if (sessioneUtente && sessioneUtente.ruolo === "RAF-RULSS" && (gruppo.codiceGruppo.toUpperCase() === "RAF-RULSS" || gruppo.codiceGruppo.toUpperCase() === "RAF-RDS")) {
                    gruppiApplicazione.push(gruppoApplicazione)
                }
                if (sessioneUtente && sessioneUtente?.ruolo?.toUpperCase() === "RAF-RDS" && gruppo.codiceGruppo.toUpperCase() === "RAF-RDS") {
                    gruppiApplicazione.push(gruppoApplicazione)
                }
                if (sessioneUtente && (sessioneUtente?.ruolo?.toUpperCase() === "RAF-ADMIN" || sessioneUtente?.ruolo?.toUpperCase() === "RAF-RDSS")) {
                    gruppiApplicazione.push(gruppoApplicazione)
                }

            })
            gruppiApplicazione = gruppiApplicazione.filter((gruppo, index, self) =>
                    index === self.findIndex((t) => (
                        t.codice === gruppo.codice && t.descrizione === gruppo.descrizione
                    ))
            )
            Utils.saveSuggestionsSportelli(setShowSpinner, setSuggestionsSportelli)
            return setGruppiPerApplicazione(gruppiApplicazione)
        }).catch(reason => {
            Utils.saveSuggestionsSportelli(setShowSpinner, setSuggestionsSportelli)
            console.log("Errore durante il recupero dei gruppi realtivi all'applicazione: " + reason)
        })
    }

    static isCFValid(CF) {
        return !!(CF.match(
                /^(?:[A-Z][AEIOU][AEIOUX]|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i
            ) &&
            this.checkCFLastDigit(CF));
    }

    static checkCFLastDigit(cf) {
        let validi, i, s, set1, set2, setpari, setdisp;
        if (cf === "") return "";
        cf = cf.toUpperCase();
        if (cf.length !== 16) return false;
        validi = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        for (i = 0; i < 16; i++) {
            if (validi.indexOf(cf.charAt(i)) === -1) return false;
        }
        set1 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        set2 = "ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ";
        setpari = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        setdisp = "BAKPLCQDREVOSFTGUHMINJWZYX";
        s = 0;
        for (i = 1; i <= 13; i += 2)
            s += setpari.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
        for (i = 0; i <= 14; i += 2)
            s += setdisp.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
        return s % 26 === cf.charCodeAt(15) - "A".charCodeAt(0);

    }

    static todayDate() {
        let today = new Date();
        let dd = String(today.getDate()).padStart(2, '0');
        let mm = String(today.getMonth() + 1).padStart(2, '0');
        return dd + "/" + mm + "/" + today.getFullYear();
    }


}
